'use client'

import ShareICons from '@/components/share-link-icons/shareIcons'
import { FacebookShareButton, TwitterShareButton } from 'react-share'
import Link from 'next/link'
import { ToastContainer, toast } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'

interface IProps {
  urlToShare?: string
  pageTitle?: string
  specialLayout?: boolean
  campaignTitle?: string
}

export const ShareLinkIcons = ({
  urlToShare,
  pageTitle,
  specialLayout = false,
  campaignTitle,
}: IProps) => {
  const imagePath = '/images/favicons/'
  const imageSuffix = '.svg'
  const urlShare = urlToShare ? urlToShare : ''

  const subjectGmail = pageTitle
  const bodyGmail = `Read more at ${urlToShare}`
  const shareGmail = `https://mail.google.com/mail/?view=cm&fs=1&su=${subjectGmail}&body=${bodyGmail}`

  function copyToClipboard() {
    navigator.clipboard.writeText(urlShare)
    toast('Link copied to clipboard', {
      position: 'bottom-left',
      autoClose: 2000,
      hideProgressBar: true,
      closeOnClick: true,
      pauseOnHover: false,
      draggable: false,
      progress: undefined,
      theme: 'light',
    })
  }

  return (
    <div
      className={`${
        specialLayout ? '!flex-row items-center justify-center' : 'md:mt-[29px]'
      } flex justify-between items-center md:justify-normal md:items-start `}
    >
      <div>
        <p className={`text-sm ${specialLayout ? 'text-white' : 'text-black mr-4'}  font-medium`}>
          Share:
        </p>
      </div>
      <div className={`flex  ${specialLayout ? 'ml-[8px] items-center' : ''} `}>
        <FacebookShareButton url={urlShare}>
          <ShareICons
            altTag={'Facebook'}
            imageSrc={`${imagePath}${
              specialLayout ? 'faceBook-white' : 'facebook-blue'
            }${imageSuffix}`}
          />
        </FacebookShareButton>
        <TwitterShareButton url={urlShare} title={campaignTitle}>
          <ShareICons
            altTag={'X - Twitter'}
            imageSrc={`${imagePath}X${specialLayout ? '' : '-black'}${imageSuffix}`}
          />
        </TwitterShareButton>
        <Link href={shareGmail} target="_blank">
          <ShareICons altTag={'Google'} imageSrc={`${imagePath}google${imageSuffix}`} />
        </Link>
        <button onClick={copyToClipboard}>
          <ToastContainer />
          <ShareICons
            altTag={'Copy link'}
            imageSrc={`${imagePath}copy-link${specialLayout ? '-white' : ''}${imageSuffix}`}
          />
        </button>
      </div>
    </div>
  )
}

export default ShareLinkIcons
